<div class="reports-header">
  <h2>Painel de Relacionamento</h2>
</div>

<div class="flex gap-20 space-between mobile_flex-col">
  <div class="form-field">
    <mat-form-field appearance="outline" class="density-mat-form-3">
      <mat-select data-cy="awardProgramId" [placeholder]="placeHolderCombo" [(ngModel)]="awardProgramModel"
        (selectionChange)="onAwardProgramChange($event)">
        <mat-option *ngFor="let awardProgram of awardPrograms" [value]="awardProgram.id">
          {{awardProgram.description}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="flex gap-24 center mb-12 mobile_flex-wrap">
    <div class="classifiers flex flex-column">
      <div class="flex align-right gap-8">
        <div class="icon-circle-classifier mobile_icon-circle-classifier icon-circle-light-blue icon-blue">
          @if (awardProgramPanel?.previous?.imageUrl) {
          <img class="fit-image-classfier mobile_fit-image-classfier" [src]="awardProgramPanel?.previous?.imageUrl"
            [alt]="'Logo de classificação ' + awardProgramPanel?.previous?.description" />
          } @else {
          <span class="fit-size">
            <mat-icon class="material-symbols-outlined icon-color-blue">trophy</mat-icon>
          </span>
          }
        </div>
        <div class="flex classifier">
          <span class="uppercase text-blue text-nowrap mobile_text-blue ">{{awardProgramPanel?.previous?.description ??
            "Não Classificado"}}</span>
          <mat-divider [style.border-color]="awardProgramPanel?.previous?.color"
            class="custom-divider mobile_custom-divider"></mat-divider>
          <span class="footer-text mobile_footer-text">Classificação Anterior</span>
        </div>
      </div>
    </div>

    <div class="classifiers flex flex-column">
      <div class="flex align-right gap-8">
        <div class="icon-circle-classifier mobile_icon-circle-classifier icon-circle-light-blue icon-blue">
          @if (awardProgramPanel?.actual?.imageUrl) {
          <img class="fit-image-classfier mobile_fit-image-classfier" [src]="awardProgramPanel?.actual?.imageUrl"
            [alt]="'Logo de classificação ' + awardProgramPanel?.actual?.description" />
          } @else {
          <span class="fit-size">
            <mat-icon class="material-symbols-outlined icon-color-blue">trophy</mat-icon>
          </span>
          }
        </div>
        <div class="flex classifier ">
          <span class="uppercase text-blue text-nowrap mobile_text-blue ">{{awardProgramPanel?.actual?.description ??
            "Não Classificado"}}</span>
          <mat-divider [style.border-color]="awardProgramPanel?.actual?.color"
            class="custom-divider mobile_custom-divider"></mat-divider>
          <span class="footer-text mobile_footer-text ">Classificação Atual</span>
        </div>
      </div>
    </div>
  </div>
</div>

<br>

<div *ngIf="isLoading" class="loading-spinner-container">
  <mat-spinner class="spinner"></mat-spinner>
</div>

<div class="flex flex-column justify-start align-start overflow-auto gap-6" *ngIf="!isLoading">
  <div class="estricta bolder">
    Última Atualização: {{
    !!awardProgramPanel?.lastUpdated ? (awardProgramPanel?.lastUpdated | date: 'dd/MM/yyyy HH:mm:ss') : "-" }}
  </div>

  <div class="scroll-container margin-bottom-16 justify-start align-start">
    <div class="flex gap-20 scrollable align-start justify-start">
      @for (item of awardProgramPanel?.criteriasDashboard; track $index) {
      <mat-card appearance="outlined" class="criterias mobile_criterias"
        [ngClass]="{'cursor-pointer': hasPermissionReadCriteria }" (click)="selectAwardProgramCriteriaData(item)">
        <mat-card-content class="card-content">
          <div class="flex gap-16">
            <div class="icon-circle icon-circle-light-blue icon-blue">
              <mat-icon class="material-icons-outlined reflect-icon">sell</mat-icon>
            </div>
            <span *ngIf="!item.value" class="bolder sell-category-value-text">0</span>
            <span *ngIf="item.value" class="bolder sell-category-value-text">{{item.value | number:'1.2-2' }}</span>
          </div>
          <span class="sell-category-description-text">{{item.description}}</span>
        </mat-card-content>
      </mat-card>
      }
    </div>
  </div>
</div>
